module.exports = __webpack_public_path__ + "img/nora-avatar.37728759.png";